class ConsultaTributacaoCest {
    constructor($scope, $filter, modal, ConsultaTributaria) {
        this.apply = fun => $scope.$apply(fun)
        this.$filter = $filter
        this.modal = modal
        this.ConsultaTributaria = ConsultaTributaria
    }

    $onInit() {
        this.filtro = { exTipi: '' }
    }

    hasAcesso(empresa) {
        return empresa.ferramentasDisponiveis.includes("consulta-simples-tributacao-cest")
    }

    configurarIcms() {
        this.modal
            .open({
                component: 'configuracaoIcmsModal',
                size: 'lg',
                keyboard: 'static',
                resolve: {
                    empresaId: () => this.contratoId,
                    filialId: () => this.empresa.id
                }
            })
            .result
            .then(() => this.consultarTributacao(form))
    }

    configurarPisCofins() {
        this.modal
            .open({
                component: 'configuracaoPisCofinsModal',
                size: 'lg',
                keyboard: 'static',
                resolve: {
                    empresaId: () => this.contratoId,
                    filialId: () => this.empresa.id
                }
            })
            .result
            .then(() => this.consultarTributacao(form))
    }

    pesquisarNcm(ncm = this.filtro.ncm) {
        this.modal
            .open({
                component: 'consultaNcmModal',
                size: 'lg',
                keyboard: 'static',
                resolve: {
                    ncm: () => ncm && ncm.replace(/\D/g, ''),
                    contratoId: () => this.contratoId
                }
            })
            .result
            .then(ncm => {
                if (ncm)
                    this.filtro.ncm = ncm
            })
    }

    consultar(ncm) {
        this.filtro.ncm = ncm
        this.consultarTributacao(form)
    }

    consultarTributacao(form) {
        if (!form.$valid) return;

        if (this.filtro.ncm == null)
            this.filtro.ncm == '';
        else
            this.filtro.ncm = this.filtro.ncm.replace(/\D/g, '')

        this.consulta = null
        this.error = null

        const filtro = {
            ...this.filtro,
            contrato: this.empresa.id,
            ncm: this.filtro.ncm
        }

        this.promise = this
            .ConsultaTributaria
            .consultaTributacao(filtro)
            .then(consulta => this.consulta = consulta)
            .catch(code => this.error = this.getMessage(code))
    }

    getMessage(code) {
        switch (code) {
            case 'ncm_inexistente':
                return `A NCM <strong>${this.filtro.ncm}</strong> não foi encontrada.`
            case 'contrato_inexistente':
                return 'Não foi encontrado uma empresa. Selecione uma empresa para realizar a consulta.'
            case 'cest_not_found':
                return 'Nenhuma CEST foi encontrada para o NCM informado.'
            case 'parametros_insuficientes':
                return 'Os parâmetros informados são insuficientes para realizar a consulta.'
            default:
                return 'Ocorreu um erro ao carregar os dados.'
        }
    }
}

angular.module("eficienciaFiscalModule")
    .component("consultaTributacaoCest", {
        controller: ['$scope', '$filter', '$uibModal', 'ConsultaTributaria', ConsultaTributacaoCest],
        bindings: {
            contratoId: '<'
        },
        template: `
        <form name="form" novalidate>
            <loading promise="$ctrl.empresasPromise">
                <promise-tracker promise="$ctrl.promise" active="$ctrl.loading">
                    <div class="row">
                        <div class="col-xs-12">
                            <ef-empresa-selector
                                contrato-id="$ctrl.contratoId"
                                name="empresa"
                                ng-change="$ctrl.consulta = null"
                                ng-model="$ctrl.empresa"
                                filter="$ctrl.hasAcesso($empresa)"
                                cache-as="consulta-tributacao-cest"
                                required>
                            </ef-empresa-selector>
                        </div>
                        <div class="form-group col-xs-12 col-sm-8 col-md-5">
                            <label>
                                NCM <i class="text-danger cursor-pointer fa fa-trash-o" ng-show="$ctrl.filtro.ncm" ng-click="$ctrl.filtro.ncm = undefined"></i>
                                (<a ng-click="$ctrl.pesquisarNcm()" class="cursor-pointer">Não sabe a NCM do item? Clique aqui.</a>)
                            </label>
                            <input 
                                name="ncm"
                                ng-model="$ctrl.filtro.ncm"
                                minlength="8"
                                maxlength="10"
                                class="form-control" />
                        </div>
                        <div class="form-group col-xs-12 col-sm-4 col-md-1">
                            <label>
                                EXTIPI <i class="text-danger cursor-pointer fa fa-trash-o" ng-show="$ctrl.filtro.exTipi" ng-click="$ctrl.filtro.exTipi = ''"></i>
                            </label>
                            <input name="exTipi" ng-model="$ctrl.filtro.exTipi" maxlength="3" class="form-control" />
                        </div>
                        <div class="form-group col-xs-12 col-sm-6 col-md-3">
                            <label>
                                Código de barras <i class="text-danger cursor-pointer fa fa-trash-o" ng-show="$ctrl.filtro.codigoBarras" ng-click="$ctrl.filtro.codigoBarras = ''"></i>
                            </label>
                            <input name="codigoBarras" ng-model="$ctrl.filtro.codigoBarras" class="form-control" />
                        </div>
                        <div class="form-group col-xs-12 col-sm-6 col-md-3">
                            <label class="hidden-xs">&nbsp;</label>
                            <button 
                                class="btn btn-block btn-primary" 
                                ng-disabled="$ctrl.loading"
                                ng-click="$ctrl.consultarTributacao(form)">
                                <i class="fa fa-search"></i> Consultar
                            </button>
                        </div>
                    </div>
                    <ef-consulta-tributaria 
                        contrato-id="$ctrl.contratoId"
                        filial-id="$ctrl.empresa.id"
                        ncm="$ctrl.filtro.ncm"
                        consulta="$ctrl.consulta"
                        promise="$ctrl.promise"
                        error="$ctrl.error"
                        form="form">
                    </ef-consulta-tributaria>
                </promise-tracker>
            </loading>

            <script type="text/ng-template" id="popover-detalhes-icms">
               <detalhes-tributacao-icms icms="$context.resultado" empresa="$context.contrato"></detalhes-tributacao-icms>
            </script>
        </form>
        `
    })
